import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import { Container } from "@/components/ui/Container";
import type { BlokManuals } from "@/storyblok";
import BlokWrap from "../../BlokWrap";
import styles from "./ManualsBlok.module.css";

export const ManualsBlok = ({ blok, preview }: BlokProps<BlokManuals>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<Container>
				<p className={styles.title}>{blok.title}</p>
				<div className={styles.sections}>
					{blok.sections && (
						<StoryblokComponentList bloks={blok.sections} preview={preview} />
					)}
				</div>
			</Container>
		</BlokWrap>
	);
};
